<template>
  <div>
    <div class="modal__show-btn" @click="showModal">
      modal (イメージとテキスト) 表示
    </div>
    <TextImageModal
      v-if="showableModal"
      :image-url="imageUrl"
      :title-text="'タイトルが入ります'"
      :caption-text="'キャプションエリアです。\n詳細事項を手短に書いてください。'"
      :primary-button-text="'変更する'"
      :cancel-button-text="'閉じる'"
      @clicked-modal-cover="closeModal"
      @clicked-primary="clickedPrimary"
      @clicked-cancel="closeModal"
    />
  </div>
</template>

<script>
import TextImageModal from '../../components/molecules/modals/text-image-modal.vue'
import imageUrl from '../../../../images/styleguide/sample_modal_image_2.png'

export default {
  components: { TextImageModal },
  data() {
    return {
      showableModal: false,
      imageUrl
    }
  },
  methods: {
    showModal() {
      this.showableModal = true
    },
    closeModal() {
      this.showableModal = false
    },
    clickedPrimary() {
      window.alert('clicked primary button!')
      this.closeModal()
    }
  }
}
</script>
